import { Component, Injector, OnInit } from '@angular/core';
import { MBOMService, ProgramDetailsBodyService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../../../shared/filterable-service';

@Component({
  selector: 'app-m-bom',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class MBOMComponent extends BaseGridComponent implements OnInit {

  public descMaxLength: number = null;
  private readonly bodyProgramService: ProgramDetailsBodyService;
  private readonly programService = new FilterableService();

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: MBOMService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.bodyProgramService = injector.get(ProgramDetailsBodyService);
    this.descMaxLength = 20;
    this.appCardTitle = 'mBOMs';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'mBOM',
      },
      {
        field: 'ProgramCode',
        title: 'Program',
        type: 'dropdown',
        service: this.programService,
        textField: 'ProgramCode',
        valueField: 'ProgramId',
        name: 'ProgramId',
        refreshSecondaryData: this.populateProgramList,
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      ProgramDescription: [],
      Description: ['',  Validators.required],
      ProgramId: ['', Validators.required],
      IsActive: [],
      AuditDto: [],
     });
  }

  populateProgramList(dataItem: any) {
    dataItem.bodyProgramService.read('?activeOnly=true')
    .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode));
      }
      dataItem.programService.next(result);
    });
  }
}
